
import React from 'react';
import { DollarSign, TrendingUp, Coins, Banknote } from 'lucide-react';

export const FloatingElements = () => {
  const icons = [DollarSign, TrendingUp, Coins, Banknote];
  
  return (
    <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
      {Array.from({ length: 8 }).map((_, i) => {
        const Icon = icons[i % icons.length];
        const delay = i * 0.5;
        const duration = 3 + (i % 3);
        
        return (
          <Icon
            key={i}
            className={`absolute w-6 h-6 text-yellow-400/20 animate-bounce`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`,
            }}
          />
        );
      })}
    </div>
  );
};
